/**
 * @fileoverview PUT handler for the "/engagement/landing_page_template(/:id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPageTemplateIdCacheKeys } from "./constants";
import type { PutEngagementLandingPageTemplateIdProps, EngagementLandingPageTemplateIdResult } from "./types";

export const putEngagementLandingPageTemplateId = reactQueryMutationAdapter(
  engagementLandingPageTemplateIdCacheKeys,
  (props: PutEngagementLandingPageTemplateIdProps): Promise<EngagementLandingPageTemplateIdResult> => {
    return fetch(`/engagement/landing_page_template${props.id ? `/${props.id}` : ""}`, "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
